import { Avatar, Chip, Grid, Typography } from "@mui/material"
import useStyles from "./useStyles"
//import { useSelector } from "react-redux"

export const SuborganizationAsoc = ({ data }) => {
  const classes = useStyles()

  const client = data?.[0]
  return (
    <>
      <div
        style={{
          marginTop: 30,
          paddingLeft: "5%",
          fontWeight: "bold",
          fontSize: "20px",
          color: "#4B4952",
        }}
      >
        Datos del Cliente
      </div>
      {client && (
        <>
          <Grid
            container
            className={classes.boxDetails}
            key={client.customerSuborganizationCuit}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                padding: "10px 0",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginLeft: "5%",
                  minWidth: "80px",
                }}
              >
                <Avatar
                  src={
                    client.suborganizationBasePictureURL
                      ? `${client.suborganizationBasePictureURL}/${client.suborganizationLogoPictureURL}`
                      : null
                  }
                  sx={{
                    bgcolor: client.customerSuborganizationAvatar?.color,
                    width: 60,
                    height: 60,
                  }}
                >
                  {client.customerSuborganizationAvatar?.initials}
                </Avatar>
              </div>
              <div
                className={classes.boxEstudioCustomer}
                style={{
                  flex: 1,
                  paddingLeft: 20,
                  paddingRight: 20,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                {" "}
                <Typography
                  style={{
                    fontSize: "20px",
                    color: "#4B4952",
                    paddingLeft: 10,
                  }}
                >
                  {" "}
                  <b>Cliente:</b> {client?.customerSuborganizationName}
                </Typography>
                <Typography
                  style={{
                    fontSize: "15px",
                    paddingLeft: 10,
                    color: "#4B4952",
                    marginRight: 10,
                  }}
                >
                  <b>CUIT:</b> {client?.customerSuborganizationCuit}
                </Typography>{" "}
              </div>
              <div
                style={{
                  marginRight: "5%",
                }}
              >
                <Chip
                  label={`${data?.length || 0} Estudio${
                    data?.length !== 1 ? "s" : ""
                  }`}
                  sx={{
                    backgroundColor: "#e8f5e8",
                    color: "#2e7d32",
                    fontWeight: "bold",
                    marginRight: "10%",
                  }}
                />
              </div>
            </div>
          </Grid>
        </>
      )}
      <div
        style={{
          marginTop: 40,
          paddingLeft: "5%",
          fontWeight: "bold",
          fontSize: "20px",
          color: "#4B4952",
        }}
      >
        Estudios Asociados
      </div>

      {data &&
        data.map((suborganization) => (
          <Grid
            container
            className={classes.boxDetails}
            key={suborganization.customerSuborganizationCuit}
          >
            <div className={classes.boxEstudio}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignItems: "center",
                  padding: 1,
                  width: "15%",
                }}
              >
                <Avatar
                  src={
                    suborganization.suborganizationBasePictureURL
                      ? `${suborganization.suborganizationBasePictureURL}/${suborganization.firmSuborganizationLogoPictureURL}`
                      : null
                  }
                  sx={{
                    bgcolor: suborganization.firmSuborganizationAvatar?.color,
                    width: 60,
                    height: 60,
                  }}
                >
                  {suborganization.firmSuborganizationAvatar?.initials}
                </Avatar>
              </div>
              <div
                style={{
                  fontSize: "17px",
                  marginBottom: 5,
                  display: "flex",
                  flexDirection: "column",
                  width: "35%",
                  color: "#4B4952",
                }}
              >
                <div style={{ marginBottom: "5px" }}>
                  <b>Organización Asociada:</b>{" "}
                  {suborganization.organizationName}
                </div>
                <div>
                  <b>CUIT Organización: </b>
                  {suborganization.organizationCuit}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignContent: "center",

                  fontSize: "15px",
                  color: "#4B4952",
                }}
              >
                <div
                  style={{
                    fontSize: "17px",
                    marginBottom: 5,
                    display: "flex",
                    flexDirection: "column",
                    width: "400px",
                    borderLeft: "2px solid #E0E0E0",
                    paddingLeft: "5%",
                  }}
                >
                  <div style={{ marginBottom: "5px" }}>
                    <b>Estudio: </b>
                    {suborganization.firmSuborganizationName}
                  </div>
                  <div>
                    {" "}
                    <b>CUIT Estudio:</b>{" "}
                    {suborganization.firmSuborganizationCuit}
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        ))}
    </>
  )
}
